import React from 'react';

const LoadingScreen = ({ message = 'Loading...' }) => (
  <div className="loading-screen">
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <rect width="48" height="48" rx="12" fill="#2D6A4F" />
      <text x="50%" y="54%" dominantBaseline="middle" textAnchor="middle"
        fontSize="24" fill="white" fontFamily="Georgia, serif">W</text>
    </svg>
    <div className="spinner" style={{ marginTop: 8 }} />
    <p style={{ color: 'var(--color-text-3)', fontSize: '0.875rem' }}>{message}</p>
  </div>
);

export default LoadingScreen;
